import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BackgroundService {

  constructor() { }

  getImage(){
    return 'background-images/'+Math.floor(Math.random() * 2 + 1)+'.png';
  }

  formatBackgroundImage(imageUrl?: string): string | undefined {
    return imageUrl ? 'url(' + imageUrl + ')' : undefined;
  }
}
